import { TaskViewSettings } from '../types';
import { GetTaskListRequestSortModel } from './GetTaskListRequestSortModel';
import { PageRequestModel } from './PageRequestModel';

/**
 * * Модель запроса на подгрузку задач по приоритету
 */
export class GetByPriorityTasksRequestModel {
  /**ID приоритета */
  PriorityId!: number;
  /**ID очереди */
  QueueTaskId!: string;
  /**Настройки отображения */
  ViewSettings!: TaskViewSettings;
  /**Пагинация */
  Page!: PageRequestModel;
  /**Строка поиска */
  Search?: string;
  /**Сортировка */
  Sort!: GetTaskListRequestSortModel;

  constructor(obj?: Partial<GetByPriorityTasksRequestModel>) {
    Object.assign(this, obj);
  }
}
